import { memo, useCallback } from 'react'

import { CallMissedOutgoing, StopCircle } from '@mui/icons-material'
import { MenuItem, ListItemIcon, Typography, Divider } from '@mui/material'
import { AvcInstanceTask } from '@nativewaves/nw-cloud-sdk/content'
import { useNavigate } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { MenuItemConfirm, MenuItemCopyId } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useStopMutation } from 'hooks/mutations/content'
import { dashboardRoute } from 'pages/NWPlatform/AvcSystem/Instances/Instance'
import { avcTaskConfigRoute } from 'pages/NWPlatform/Workspaces/Workspace/AvcTasks/AvcTask'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<AvcInstanceTask>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])

  const navigate = useNavigate({ from: avcTaskConfigRoute.fullPath })

  const { mutate: stopAvcInstanceTask } = useStopMutation()

  const handleStopAvcInstanceTask = useCallback(() => {
    onClose()

    setTimeout(() => {
      stopAvcInstanceTask({
        instanceId: row.original.avcInstanceId,
        taskId: row.original.id,
      })
    }, 300)
  }, [onClose, row.original.avcInstanceId, row.original.id, stopAvcInstanceTask])

  return (
    <>
      <MenuItem
        onClick={() => navigate({ to: dashboardRoute.to, params: { avcInstanceId: row.original.avcInstanceId } })}
      >
        <ListItemIcon>
          <CallMissedOutgoing />
        </ListItemIcon>
        <Typography sx={{ width: '100%' }}>
          {t('goTo', { target: t('entity:content.avcInstance', { count: 1 }) })}
        </Typography>
      </MenuItem>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <MenuItemCopyId
        staticLabel={t('domain:Workspace.AvcTask.copyAvcInstanceId')}
        onSuccess={onClose}
        id={row.original.avcInstanceId}
      />
      <Divider component="li" />
      <MenuItemConfirm
        staticLabel={t('domain:Workspace.AvcTask.stopTask')}
        onConfirm={handleStopAvcInstanceTask}
        startIcon={<StopCircle color="error" />}
      />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
